export default __webpack_public_path__ + "static/media/autocomplete.b386dbb5.svg";